import { render, staticRenderFns } from "./RateCardEditForm.vue?vue&type=template&id=5f3710d6&"
import script from "./RateCardEditForm.vue?vue&type=script&lang=js&"
export * from "./RateCardEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports